import { LOGIN_PATH } from 'constants/navigation';
import { getCurrentUrl } from 'utils/window';

class SocialNetworks {
  constructor(courseTitle, storageUrl) {
    this.courseTitle = courseTitle;
    this.storageUrl = storageUrl;
    this.location = `${getCurrentUrl()}#${LOGIN_PATH}`;
  }

  getAuthLink(socialNetwork) {
    return `${this.storageUrl}/auth/${socialNetwork}?courseLink=${encodeURIComponent(
      this.location
    )}&courseTitle=${encodeURIComponent(this.courseTitle)}`;
  }
}

export default SocialNetworks;
